module.exports = __webpack_public_path__ + "img/screening-send.2de9cdc2.svg";